import React from "react";
import logo from "../logo.png"
import "./footer.scss";
import { useNavigate } from "react-router-dom";
function Footer() {
  const navigate = useNavigate()
  let getDate = new Date();
  let year = getDate.getFullYear();
  const email = "info@test.de";
  const tel = "015114766666";
  const city = '41749 Viersen';
  const street = 'Spenglerstrasse 10';

  const navigateFunction = (route) => {
    navigate('/'+ route)
    window.scroll({top:0,behavior:'smooth'})
  }

  return (
    <footer>
      <div className="left-footer">
        <img src={logo} alt="" />
        <h2>Nassco Transport GmbH</h2>
      </div>
      {/* <a href={`mailto:${email}`}>E-Mail: {email}</a> */}
      {/* <a href={`tel:${tel}`}>Telefonnummer: {tel}</a>
      <h4>{street}</h4>
      <h4>{city}</h4> */}
      <div className="right-footer">
        <a onClick={() => navigateFunction('impressum')}>Impressum</a>
        <a onClick={() => navigateFunction('datenschutzerklaerung')}>Datenschutzerklärung</a>
        <a onClick={() => navigateFunction('aboutUs')}>Über uns</a>
      </div>
    </footer>
  );
}

export default Footer;
